'use strict';

var createInstanceFromPrototype = Object.create || function(prototype) {
  var ctor = function() {};
  ctor.prototype = prototype;
  return new ctor;
};

module.exports = createInstanceFromPrototype;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/function/var/createInstanceFromPrototype.js
// module id = 1168
// module chunks = 0